module.exports = __webpack_public_path__ + "img/dots.6409c1ba.jpg";